import * as React       from "react";

import "./social-download-btn.scss";

import {cst, cstAssign} from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {Types}          from "@Common/types";
import {Button}         from "@Common/tools/cc-integration/ui/button/button";

import {templateDownloadModal} from "../template-download-modal/template-download-modal";

export const SocialDownloadBtn = ({
/*  PROPS  ************************************************************************************************************/
    changed,
    highResProducts,
    itemName,
    itemId,
    templateId,
    templateOptions,
    loadProdFiles,
}:{
/*  PROP TYPES  *******************************************************************************************************/
    changed              : boolean,
    highResProducts      : any,
    itemName             : string,
    itemId               : string,
    templateId               : string,
    templateOptions      : any,
    loadProdFiles        : () => any,
}) => cst<{
/*  CS ASSIGNMENT NODE TYPES  *****************************************************************************************/
    sharing              : any,
    state                : Types.Common.React.UseState.UseStateNext<{
        downloadPercent  : number,
    }>
}>(
    cstAssign("sharing", (_, next) => templateDownloadModal({
        allowSocialShare: templateOptions?.["allowSocialShareMain"],
        itemId,
        templateDownloadUrl: highResProducts?.["jpg"]?.[0],
        templateId,
        templateName: itemName?.trim(),
        next
    })),
    // set state vars
    cstAssign("state", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })),

    // render component
    ({sharing, state}) => (
        <div className="social-download-btn-n8s">
            <Button
                buttonText="Social Post"
                xdQaName="Social Post"
                downloadProgressPercent={state.value.downloadPercent}
                onClick={async () => {

                    const highResProducts1 = (changed || !highResProducts || !Array.isArray(highResProducts?.jpg) ) ? (
                        await loadProdFiles()
                    ) : (
                        highResProducts
                    );
                    if (highResProducts1) {
                        sharing.show()
                    }

                    // remove download percent after another second to ensure that 100% status is displayed to the user
                    await setTimeout(() => state.onChange({...state.value, downloadPercent: 0}), 1000);
                }}
            />
        </div>
    )
);
